export { ScrollArea } from "@mantine/core";
export type { ScrollAreaProps } from "@mantine/core";

export { getScrollAreaOverrides } from "./ScrollArea.styled";
